import { z } from 'zod';
const isNotEmpty = (val) => !(val === undefined || val === null || val.trim() === '');
const isEmail = (val) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(val);
const isValidPassword = (password) => {
    // 길이 체크
    if (!/^.{8,}$/.test(password))
        return false;
    // 각 조건 충족 여부를 카운트
    let count = 0;
    if (/[A-Z]/.test(password))
        count++; // 대문자
    if (/[a-z]/.test(password))
        count++; // 소문자
    if (/[0-9]/.test(password))
        count++; // 숫자
    if (/[!@#$%^&*()_+=[\]{};':"\\|,.<>?/-]/.test(password))
        count++; // 특수문자
    return count >= 3;
};
export const schemas = {
    email: z
        .string()
        .refine((val) => isNotEmpty(val), {
        params: { i18n: 'schemas:email.required' },
    })
        .refine((val) => isEmail(val), {
        params: { i18n: 'schemas:email.invalid' },
    }),
    password: z
        .string()
        .refine((val) => isNotEmpty(val), {
        params: { i18n: 'schemas:password.required' },
    })
        .refine((val) => isValidPassword(val), {
        params: { i18n: 'schemas:password.validation' },
    }),
    captchaToken: z.string().refine((val) => isNotEmpty(val), {
        params: { i18n: 'schemas:captcha.required' },
    }),
    code: z.string().refine((val) => isNotEmpty(val), {
        params: { i18n: 'schemas:code.required' },
    }),
};
//# sourceMappingURL=schemas.js.map